import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-95">
      <div className="max-w-6xl mx-auto" data-id="element-96">
        <div className="mb-6" data-id="element-97">
          <p className="font-bold text-white text-xl mb-2" data-id="element-98">
            Mega-Pack Educazione Fisica
          </p>
          <p data-id="element-99">Il sistema completo per insegnanti.</p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-100">
          <a href="#" className="hover:text-white transition-colors" data-id="element-101">
            Termini e Condizioni
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-102">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-103">
            Cookie Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-104">
            Contattaci
          </a>
        </div>

        <p className="mb-4 text-xs max-w-3xl mx-auto opacity-60" data-id="element-105">
          Questo sito non fa parte del sito Facebook o Facebook Inc. Inoltre,
          questo sito NON è approvato da Facebook in alcun modo. FACEBOOK è un
          marchio registrato di FACEBOOK, Inc. I risultati mostrati in questa
          pagina sono indicativi e non garantiscono risultati identici.
        </p>

        <p data-id="element-106">&copy; {currentYear} Tutti i diritti riservati.</p>
      </div>
    </footer>;
}